import React, { Component, createRef } from "react";
import L from "leaflet";
import {
  Map,
  Marker,
  GeoJSON,
  TileLayer,
  Polyline,
  CircleMarker,
  Popup,
} from "react-leaflet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  convert,
  selectGrave,
  updateClosestPosition,
  updatePositionBounds,
} from "../../redux/actions";
import CurrentLocationMarker from "../current-location-marker";
import { oliwa, lostowice } from "../../constants";

require("leaflet-providers");
const geoutil = require("leaflet-geometryutil");

class GravesMap extends Component {
  constructor(props) {
    super(props);
    this.mapRef = createRef();
    this.geojsonRef = createRef();

    this.state = {
      lat: 54.41155,
      lng: 18.55625,
      zoom: 15,
      minZoom: 14,
      maxZoom: 18,
      bounds: null,
    };

    this.layers = null;
  }

  onCurrentPositionChange = (position) => {
    this.setState({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  };

  onGetBoundaries = (map) => {
    const { innerWidth } = window;
    let north = 54.3787;
    let south = 54.3676;
    let west = 18.5572;
    let east = 18.5908;
    let lat = 54.3738;
    let lng = 18.571;
    let zoom = 16;

    if (innerWidth <= 1120) {
      lat = 54.3705;
      lng = 18.5833;
      zoom = 15;
    }

    if (this.props.data.name === oliwa.var) {
      north = 54.4189;
      south = 54.4078;
      west = 18.5319;
      east = 18.5656;
      lat = 54.41372;
      lng = 18.55293;
      zoom = 17;

      if (innerWidth <= 1120) {
        lat = 54.4123;
        lng = 18.5586;
        zoom = 16;
      }
    } else if (this.props.data.name === lostowice.var) {
      north = 54.3478;
      south = 54.3323;
      west = 18.56245;
      east = 18.605;
      lat = 54.3403;
      lng = 18.5695;
      zoom = 15;
      if (innerWidth <= 1120) {
        lat = 54.3377;
        lng = 18.5935;
        zoom = 14;
      }
    }

    let southWest = L.latLng(south, west),
      northEast = L.latLng(north, east),
      bounds = L.latLngBounds(southWest, northEast);

    this.setState({ bounds });
    map.setView(new L.LatLng(lat, lng), zoom);
  };

  componentDidMount() {
    this.onGetBoundaries(this.mapRef.current.leafletElement);
    if (window.innerWidth <= 1120) {
      this.setState({ zoom: 15 });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.geojsonRef.current &&
      this.geojsonRef.current.leafletElement &&
      Object.values(this.geojsonRef.current.leafletElement._layers).length >
        0 &&
      !this.layers
    ) {
      this.layers = Object.values(
        this.geojsonRef.current.leafletElement._layers
      );
    }
    if (
      !this.props.loading &&
      prevProps.loading !== this.props.loading &&
      this.layers
    ) {
      this.props.dispatch(
        convert(this.mapRef.current.leafletElement, Object.values(this.layers))
      );
    }

    if (
      prevProps.data.name !== this.props.data.name &&
      this.mapRef.current.leafletElement
    ) {
      this.onGetBoundaries(this.mapRef.current.leafletElement);
    }

    if (prevProps.showMyLoc !== this.props.showMyLoc) {
      this.mapRef.current.leafletElement.setView(
        new L.LatLng(
          this.props.data.currentPos.lat,
          this.props.data.currentPos.lng
        )
      );
    }

    if (
      prevProps.data.currentPos.lat !== this.props.data.currentPos.lat &&
      prevProps.data.currentPos.lng !== this.props.data.currentPos.lng &&
      this.layers
    ) {
      let point = new L.LatLng(
        this.props.data.currentPos.lat,
        this.props.data.currentPos.lng
      );
      let closest = geoutil.closestLayerSnap(
        this.mapRef.current.leafletElement,
        this.layers,
        point
      );

      this.props.dispatch(updateClosestPosition(closest.latlng));
      let inBounds = this.state.bounds.contains(point);

      if (inBounds !== this.props.data.currentPosInBounds) {
        this.props.dispatch(updatePositionBounds(inBounds));
      }
    }
    if (this.props.data.name !== prevProps.data.name && this.geojsonRef) {
      this.geojsonRef.current.leafletElement.eachLayer((layer) =>
        layer.setStyle({
          color: this.props.data.color,
        })
      );
    }
  }

  render() {
    const myPosIcon = L.divIcon({
      iconSize: [74, 20],
      iconAnchor: [34, 35],
      html: `<span class="marker__icon" >WEJŚCIE</span>`,
    });

    return (
      <Map
        center={[this.state.lat, this.state.lng]}
        zoom={this.state.zoom}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoomControl={false}
        ref={this.mapRef}>
        <GeoJSON
          style={{ color: this.props.data.color, weight: 1 }}
          data={this.props.data.paths}
          ref={this.geojsonRef}
        />

        {this.props.data.graves &&
          !!this.props.data.graves.length &&
          this.props.data.graves
            .filter((e) => e.Cemetery === this.props.data.name)
            .map((grave) => (
              <CircleMarker
                key={grave.ID}
                onClick={() => {
                  this.props.history.push(
                    `/${
                      this.props.data.name
                    }/grave/${this.props.data.graves.indexOf(grave)}`
                  );
                  this.props.dispatch(selectGrave(grave.ID));
                }}
                color={
                  this.props.data.selectedGrave === grave.ID
                    ? "#fff"
                    : "#d1c5cf"
                }
                fillOpacity={1}
                opacity={this.props.data.selectedGrave === grave.ID ? 0.6 : 0}
                radius={this.props.data.selectedGrave === grave.ID ? 4 : 2}
                weight={this.props.data.selectedGrave === grave.ID ? 10 : 20}
                center={grave.geometry.coordinates}>
                <Popup>
                  <p>
                    <strong>
                      {grave.FirstName} {grave.LastName}
                    </strong>
                  </p>
                </Popup>
              </CircleMarker>
            ))}

        {this.props.data.currPath && (
          <Polyline
            color='#ffffff'
            weight={2}
            fillOpacity={1}
            opacity={1}
            positions={this.props.data.currPath.map((pos) =>
              pos[0] > pos[1] ? pos : pos.reverse()
            )}
          />
        )}

        {this.props.data.pathToPath && (
          <Polyline
            color='#ffffff'
            weight={2}
            fillOpacity={1}
            opacity={1}
            key={`pPoly-${this.props.data.name}`}
            positions={this.props.data.pathToPath.map((pos) =>
              pos[0] > pos[1] ? pos : pos.reverse()
            )}
          />
        )}

        <CurrentLocationMarker
          closesPosition={this.state.closesPosition}
          position={[this.state.lat, this.state.lng]}
          onChange={this.onCurrentPositionChange}
        />

        {this.props.data.entry && (
          <Marker
            key={this.props.data.entry}
            position={
              this.props.data.entry[0] > this.props.data.entry[1]
                ? this.props.data.entry
                : this.props.data.entry.reverse()
            }
            icon={myPosIcon}
          />
        )}

        <TileLayer
            url="https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}{r}.png?key=cb1_4fhh_1_28bf968906475c5acda657fa"
            opacity={0.55}
            attribution='&copy; OpenStreetMap contributors &copy; CARTO'
          />
      </Map>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default connect(mapStateToProps)(withRouter(GravesMap));



// WEBPACK FOOTER //
// ./src/js/components/graves-map/index.js